import { TableObjectModel } from '../../../../../shared/components/ui/Table/models/table-object.model';

export const getSortHandler = (sortStyle: TableObjectModel<string>): void => {
  console.warn(sortStyle);
};
